import axios from "axios";
import { API_ENDPOINTS } from "../../../config/endpoints.config";
import {
  EntityOptionsRequestBody,
  EntityOptionsResponse,
} from "../../models/entitySelector/entitySelector.model";

export const getEntityOptions = async (
  body: Omit<EntityOptionsRequestBody, "type">,
  options: { signal?: AbortSignal } = {}
): Promise<EntityOptionsResponse> => {
  const requestBody: EntityOptionsRequestBody = {
    pageSize: body.pageSize ?? 100,
    pageIndex: body.pageIndex ?? 0,
    type: 3,
  };
  return axios
    .post(API_ENDPOINTS.USER_MASTER_DATA, requestBody, {
      headers: {
        "Content-Type": "application/json",
      },
      signal: options.signal,
    })
    .then(({ data }) => data)
    .catch((error) => error);
};

export {};
